export default __webpack_public_path__ + "static/media/Warehouse.1ba19bae.svg";